import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleFavorite,removeWishlist } from '../store/slices/favoriteSlice'

const Favorite=()=>{
   const{isFavoriteOpen,FavoriteItems}=useSelector((state)=>state.favorite);



  const dispatch=useDispatch();

  const handleCloseFavorite=(close)=>{
    dispatch(toggleFavorite(close));
  };

  const handleRemove=(itemId)=>{
    dispatch(removeWishlist(itemId));
  };


  const FavoriteQuantity=FavoriteItems.length;

  const FavoriteTotal=FavoriteItems.map(item=>item.price*item.quantity).reduce((prevValue,currValue)=>prevValue+currValue,0);

  return (

      <>
            {
                isFavoriteOpen && (
                    <div id="favorite">
                        <div className="cart_content">
                            <div className="cart_head">
                                <h2>Favorite <small>({FavoriteQuantity})</small></h2>
                                <div
                                    title="Close"
                                    className="close_btn"
                                    onClick={() => handleCloseFavorite(false)}
                                >
                                    <span>&times;</span>
                                </div>
                            </div>

                            <div className="cart_body">
                                {
                                    FavoriteQuantity === 0 ? (
                                        <h2>Favotite is empty</h2>
                                    ) : (
                                        FavoriteItems.map(item => {
                                            const { id, img, title, price, quantity } = item;
                                            const itemTotal = price * quantity;
                                          
                                            return (
                                                <div className="cart_items" key={id}>
                                                    <figure className="cart_items_img">
                                                        <img src={img} alt="product-img" />
                                                    </figure>

                                                    <div className="cart_items_info">
                                                        <h4>{title}</h4>
                                                        <h3 className="price">₹ {itemTotal.toLocaleString()}</h3>
                                                    </div>

                                                    <div
                                                        title="Remove Item"
                                                        className="cart_items_delete"
                                                        onClick={() => handleRemove(id)}
                                                    >
                                                        <span>&times;</span>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )
                                }
                            </div>

                            <div className="cart_foot">
                                <h3>
                                    <small>Total:</small>
                                    <b>₹ {FavoriteTotal.toLocaleString()}</b>
                                </h3>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
  
  )
}

export default Favorite;
